"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Requester = /** @class */ (function () {
    function Requester(baseSocitalUrl, logger) {
        this.filterHeaderValues = function (headers) {
            if (!headers)
                return {};
            var filteredHeader = {};
            Object.keys(headers).forEach(function (key) {
                if (headers[key])
                    filteredHeader[key] = headers[key];
            });
            return filteredHeader;
        };
        this.baseUrl = baseSocitalUrl;
        this.logger = logger;
    }
    Requester.prototype.getResponse = function (path, query, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, res, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = "".concat(this.baseUrl).concat(path).concat(query);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(endpoint, {
                                headers: __assign({ Accept: 'application/json' }, this.filterHeaderValues(headers)),
                                method: 'GET'
                            })];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 3:
                        err_1 = _a.sent();
                        this.logger.error({ err: err_1, headers: headers }, "getJson at: ".concat(endpoint));
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Requester.prototype.getJson = function (path, query, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getResponse(path, query, headers)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    Requester.prototype.postResponse = function (path, body, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = "".concat(this.baseUrl).concat(path);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(endpoint, {
                                headers: __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, this.filterHeaderValues(headers)),
                                method: 'POST',
                                body: JSON.stringify(body)
                            })];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 3:
                        err_2 = _a.sent();
                        this.logger.error({ err: err_2, headers: headers }, "postJson at: ".concat(endpoint));
                        throw err_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Requester.prototype.postJson = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postResponse(path, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    return Requester;
}());
exports.default = Requester;
//# sourceMappingURL=data:application/json;base64,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